import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api, unwrap } from '../../api/client';
import { errorMessage } from '../../api/errors';
import { useAuth } from '../../auth/AuthProvider';
import { Button, Card } from '../../design';
import { DocumentsTable } from './common';
import { UploadDialog } from './UploadDialog';

/** Secțiunea „Documente” din detaliul operațiunii (spec §4.5): lista și încărcarea cu operațiunea fixă. */
export function DocumentsCard({
  operation,
}: {
  operation: { id: string; title: string; orgId: string };
}) {
  const { has } = useAuth();
  const [uploading, setUploading] = useState(false);
  const query = useQuery({
    queryKey: ['documents', { operationId: operation.id }],
    queryFn: () =>
      unwrap(
        api.GET('/documents', {
          params: { query: { operationId: operation.id, pageSize: 50 } },
        }),
      ),
    enabled: has('documents'),
  });
  if (!has('documents')) return null;
  return (
    <Card tight>
      <div className="flex between" style={{ padding: 16 }}>
        <div>
          <h2>Documente</h2>
          <p className="muted small">
            Procese-verbale, fotografii, contracte legate de această operațiune.
          </p>
        </div>
        <Button small icon="plus" onClick={() => setUploading(true)}>
          Încarcă
        </Button>
      </div>
      <DocumentsTable
        rows={query.data?.items ?? []}
        canEdit
        compact
        empty={
          query.isLoading
            ? 'Se încarcă…'
            : query.error
              ? errorMessage(query.error)
              : 'Niciun document atașat.'
        }
      />
      {uploading && (
        <UploadDialog
          fixedOperation={operation}
          onClose={() => setUploading(false)}
          onUploaded={() => setUploading(false)}
        />
      )}
    </Card>
  );
}
